module.exports = __webpack_public_path__ + "static/media/1021415.ec745091.jpg";